const skipKeys = [
    'interaction',
    'spinner'

]
const skipProps = [
    'innerWidth',
    'backgroundUrl',
    'content'
]

const keySubstitutions = [
    {
        name: 'menu', sub: [
            { value: '.styleWrapper .menu', present: true, },
            { value: '.menu', present: false }
        ]
    },
    {
        name: 'footer', sub: [
            { value: '.styleWrapper footer', present: true, },
            { value: 'footer', present: false }
        ]
    },
    {
        name: 'main', sub: [
            { value: '.styleWrapper body, #body', present: true, },
            { value: 'body, #body', present: false }
        ]
    },
    {
        name: 'content', sub: [
            { value: '.styleWrapper main', present: true },
            { value: 'main', present: false }
        ]
    },
    {
        name: 'text', sub: [
            { value: '.styleWrapper p', present: true },
            { value: 'p', present: false }
        ]
    },
    {
        name: 'title', sub: [
            { value: '.styleWrapper h1', present: true },
            { value: 'h1', present: false }
        ]
    },
    {
        name: 'a', sub: [
            { value: '.styleWrapper a', present: true },
            { value: 'a', present: false }
        ]
    },
    {
        name: 'button', sub: [
            { value: '.styleWrapper button', present: true },
            { value: 'button', present: false }
        ]
    },
    {
        name: 'header', sub: [
            { value: '.styleWrapper header', present: true },
            { value: 'header', present: false }
        ]
    },
    {
        name: 'footer', sub: [
            { value: '.styleWrapper footer', present: true },
            { value: 'footer', present: false }
        ]
    },
    {
        name: 'subtitle', sub: [
            { value: '.styleWrapper h2', present: true },
            { value: 'h2', present: false }
        ]
    },
    {
        name: 'tcell', sub: [
            { value: '.styleWrapper td', present: true },
            { value: 'td', present: false }
        ]
    },
    {
        name: 'thead', sub: [
            { value: '.styleWrapper th', present: true },
            { value: 'th', present: false }
        ]
    },
    {
        name: 'table', sub: [
            { value: '.styleWrapper table', present: true },
            { value: 'table', present: false }
        ]
    },
    {
        name: 'label', sub: [
            { value: '.styleWrapper label', present: true },
            { value: 'label', present: false }
        ]
    },
]

const replaceKeyName = (key, presentation) => {
    let obj = keySubstitutions.find(ks => ks.name === key)
    if (!obj) return '';
    let val = obj.sub.find(s => s.present === presentation).value;
    return val;
}

const convertPseudoClassesToCss = (pclass, action, style) => {
    const pseudoClass = action.replace('&', pclass);
    style = toKebabCase({ [pseudoClass]: { ...style } });
    return style;
}
const converWebkitScroll = (scrollbar) => {
    const {
        thumbBackgroundColor,
        thumbBorderRadius,
        trackBackgroundColor,
        thumbColorHover, width } = scrollbar
    return `.jir-scroll::-webkit-scrollbar {
            width: ${width !== 'unset' ? width : '10px'} !important;
       
          }
          .jir-scroll::-webkit-scrollbar-track {
            background: ${trackBackgroundColor !== 'unset' ? trackBackgroundColor : 'transparent'} !important;
          }
          .jir-scroll::-webkit-scrollbar-thumb {
            background-color: ${thumbBackgroundColor !== 'unset' ? thumbBackgroundColor : '#aaaaaa'} !important;
            border-radius: ${thumbBorderRadius !== 'unset' ? thumbBorderRadius : '5px'} !important;
           
          }
          .jir-scroll::-webkit-scrollbar-thumb:hover {
            background-color: ${thumbColorHover !== 'unset' ? thumbColorHover : '#777777'} !important;
          }`

}

export const toKebabCase = (style, presentation = false, scroll = false) => {
    const targetObj = Object.assign({}, style);
    let styleString = ''
    if(!scroll){
        for (const key in targetObj) {
            if (!Array.isArray(targetObj[key]) && !skipKeys.includes(key)) {
                let source = `${replaceKeyName(key, presentation)}{`;
                Object.entries(targetObj[key]).reduce((styleString, [propName, propValue]) => {
                    if (propName.includes('&:')) {
                        styleString += convertPseudoClassesToCss(key, propName, propValue)
                    }
                    else if (!skipProps.includes(propName)) {
                        propName = propName.replace(/([A-Z])/g, matches => `-${matches[0].toLowerCase()}`);
                        source += `${propName}:${propName === 'font-family' ? `'${propValue}'` : propValue};`
                    }
                }, '')
                source += '}'
                styleString += source;
            }
        }
    }
  
    if (targetObj['scrollbar'] !== undefined) {
        styleString += converWebkitScroll(targetObj['scrollbar']);
    }
    if(scroll){
        styleString += converWebkitScroll(targetObj);
    }
    return styleString;
}
